import * as React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Link from "react-router-dom/es/Link";
import DoubleArrowRight from "../../components/Icons/DoubleArrowRight";
import PropTypes from "prop-types";
import { householdAction } from "../../actions/household.action";
import Calculating from "../../components/Loading/Calculating";
import { appAction } from "../../actions/app.action";

import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Slide from "@material-ui/core/Slide/Slide";
import Button from "@material-ui/core/Button/Button";

const LOSS_BAND_COLORS = [
  '#FECACA', '#FCA5A5', '#F87171', '#EF4444', '#DC2626', '#B91C1C', '#7F1D1D',
];
const LOSS_BAND_LABELS = ['−5%', '−10%', '−15%', '−20%', '−25%', '−30%', '−40%+'];

const RETURN_BAND_COLORS = [
  '#BBF7D0', '#86EFAC', '#4ADE80', '#22C55E', '#16A34A', '#14532D',
];
const RETURN_BAND_LABELS = ['0–3%', '3–6%', '6–9%', '9–12%', '12–15%', '15%+'];

const MINUS = '−';

function getLossBandIndex(riskPct) {
  if (riskPct > -7.5) return 0;
  if (riskPct > -12.5) return 1;
  if (riskPct > -17.5) return 2;
  if (riskPct > -22.5) return 3;
  if (riskPct > -27.5) return 4;
  if (riskPct > -35) return 5;
  return 6;
}

function getReturnBandIndex(rrorPct) {
  if (rrorPct < 3) return 0;
  if (rrorPct < 6) return 1;
  if (rrorPct < 9) return 2;
  if (rrorPct < 12) return 3;
  if (rrorPct < 15) return 4;
  return 5;
}

const styles = (theme) => ({
  contentWrapper: {
    padding: '80px 80px 120px',
    maxWidth: 980,
    width: '100%',
    position: 'relative',
  },
  pageTitle: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 56,
    fontWeight: 900,
    color: '#000000',
    letterSpacing: '-0.025em',
    margin: '0 0 38px',
    lineHeight: 1.05,
  },
  lede: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 17,
    lineHeight: 1.65,
    color: '#000000',
    margin: 0,
    maxWidth: 760,
    fontWeight: 400,
  },
  metricPanel: {
    margin: '36px 0 40px',
    padding: '28px 30px',
    background: '#FFFFFF',
    border: '1px solid #E5E5E0',
    position: 'relative',
  },
  metricPanelLoss: {
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 4,
      background: 'linear-gradient(180deg, #FCA5A5, #B91C1C)',
    },
  },
  metricPanelReturn: {
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 4,
      background: 'linear-gradient(180deg, #86EFAC, #14532D)',
    },
  },
  metricRow: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: 22,
  },
  metricEyebrow: {
    fontFamily: "'Roboto Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 12,
    letterSpacing: '0.22em',
    textTransform: 'uppercase',
    color: '#5C5C58',
    fontWeight: 500,
    marginBottom: 12,
  },
  metricValue: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 64,
    fontWeight: 900,
    lineHeight: 1,
    letterSpacing: '-0.035em',
    fontVariantNumeric: 'tabular-nums',
  },
  metricValueRed: { color: '#B91C1C' },
  metricValueGreen: { color: '#1F8A4D' },
  unit: {
    fontSize: 32,
    fontWeight: 700,
    marginLeft: 2,
  },
  metricCaption: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 13,
    color: '#5C5C58',
    marginTop: 8,
    maxWidth: 320,
    lineHeight: 1.5,
  },
  bandsWrap: { marginTop: 8 },
  bandMarkers: {
    position: 'relative',
    height: 24,
    marginBottom: 6,
  },
  bandMarker: {
    position: 'absolute',
    bottom: 0,
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
  },
  bandMarkerLabel: {
    background: '#FFFFFF',
    color: '#000000',
    border: '1px solid #000000',
    padding: '3px 7px 2px',
    lineHeight: 1,
    fontFamily: "'Roboto Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 10,
    letterSpacing: '0.16em',
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  bandMarkerStem: {
    display: 'block',
    width: 1,
    height: 6,
    background: '#000000',
  },
  bands: {
    display: 'flex',
    height: 14,
  },
  band: {
    flex: 1,
    position: 'relative',
    '& + &': { marginLeft: 4 },
  },
  youRow: {
    position: 'relative',
    height: 28,
    marginTop: 4,
  },
  youMarker: {
    position: 'absolute',
    top: 0,
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    pointerEvents: 'none',
  },
  youMarkerStem: {
    display: 'block',
    width: 1,
    height: 6,
    background: '#0F5C30',
  },
  youMarkerLabel: {
    background: '#0F5C30',
    color: '#FFFFFF',
    padding: '3px 9px 2px',
    fontFamily: "'Roboto Condensed', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 10,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    fontWeight: 700,
    lineHeight: 1,
  },
  bandLabels: {
    display: 'flex',
    marginTop: 4,
  },
  bandLabel: {
    flex: 1,
    textAlign: 'center',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 12,
    color: '#5C5C58',
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 500,
    '& + &': { marginLeft: 4 },
  },
  bandLabelActive: {
    color: '#000000',
    fontWeight: 700,
  },
  bodyCopy: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 17,
    lineHeight: 1.7,
    color: '#000000',
    margin: 0,
    maxWidth: 760,
    fontWeight: 400,
  },
  pullQuote: {
    margin: '36px 0',
    padding: '16px 22px',
    borderLeft: '3px solid #1F8A4D',
    background: '#E8F5EE',
  },
  pullQuoteText: {
    margin: 0,
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 13,
    lineHeight: 1.5,
    color: '#000000',
    fontWeight: 700,
  },
  disclosureText: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 11.5,
    lineHeight: 1.6,
    color: '#5C5C58',
    margin: '28px 0 0',
    maxWidth: 760,
    fontWeight: 400,
    '& strong': {
      color: '#1A1A1A',
      fontWeight: 600,
    },
  },
  disclosuresLink: {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: 20,
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 11.5,
    color: '#5C5C58',
    textDecoration: 'none',
    letterSpacing: '0.04em',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': { color: '#000000' },
  },
  controller: {
    width: theme.wbiComponent.ctaController.totalWidth,
    [theme.breakpoints.down('md')]: { width: '45px' },
    height: '100%',
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 0,
    background: `linear-gradient(-189deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 94%)`,
    boxShadow: 'inset 0 0 17px rgba(0,0,0,0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& button': {
      height: 360,
      width: '100%',
      background: 'transparent',
      cursor: 'pointer',
      border: 'none',
    },
    '@media print': { display: 'none' },
  },
  saveButtonNavItem: {
    width: theme.wbiComponent.staticNavigation.totalWidth,
    left: 0,
    textTransform: 'uppercase',
    color: theme.palette.grey[50],
    fontSize: 14,
    [theme.breakpoints.down('md')]: { fontSize: 12 },
    '& svg': {
      [theme.breakpoints.down('md')]: { width: '18px' },
    },
  },
});

class RoRReturn extends React.Component {
  state = {
    userClosedDialog: false,
  };

  componentDidMount() {
    const { household, householdId } = this.props;
    if (
      household.currentHousehold === null ||
      (household.currentHousehold.hasOwnProperty('id') &&
        household.currentHousehold.id !== householdId)
    ) {
      this.props.dispatch(householdAction.getHouseholdById(householdId));
    }
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setAddClientNav(true));
    this.props.dispatch(appAction.showCalculatingState(false));
    this.props.dispatch(appAction.updateProgressStep(3));
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.dispatch(appAction.setAddClientNav(true));
    this.props.dispatch(appAction.showCalculatingState(true));
  }

  invalidRRoRModal(isOpen, close, rror) {
    const id = this.props.householdId;
    return (
      <Dialog
        open={isOpen}
        TransitionComponent={(props) => <Slide direction="up" {...props} />}
        aria-labelledby="extreme-rror-dialog"
        aria-describedby="extreme-rror-dialog-description"
      >
        <DialogTitle id="extreme-rror-dialog-title">{`RROR Too ${rror < 0 ? 'Low' : 'High'}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="extreme-rror-dialog-description">
            Your RROR is too {rror < 0 ? 'low' : 'high'}. Press <b>OK</b> to see Cy's best
            optimization based on your inputs. Select Edit if you would like to <b>Edit</b> your
            Profile Inputs at this time.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.history.push(`/Portal/household/${id}/client`)}>
            Edit
          </Button>
          <Button onClick={close}>OK</Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { classes, household, app, householdId } = this.props;

    if (!household || !household.currentHousehold || app.calculating) {
      return <Calculating />;
    }

    const curHouse = household.currentHousehold;
    const clients = curHouse.Clients;
    const firstName = clients[0].profile.firstName;
    const hasSecondClient = clients.length > 1;
    const secondFirstName = hasSecondClient ? clients[1].profile.firstName : null;

    const riskPct = curHouse.risk * 100;
    const rrorPct = Math.max(0, curHouse.rror * 100);
    const riskAbs = Math.abs(riskPct).toFixed(2);
    const rrorAbs = Math.abs(rrorPct).toFixed(2);
    const rrorSign = rrorPct >= 0 ? '+' : MINUS;

    const activeLossBand = getLossBandIndex(riskPct);
    const activeReturnBand = getReturnBandIndex(rrorPct);
    const lossYouLeft = `${((activeLossBand + 0.5) / 7 * 100).toFixed(2)}%`;
    const returnYouLeft = `${((activeReturnBand + 0.5) / 6 * 100).toFixed(2)}%`;

    return (
      <div className={classes.contentWrapper}>
        <h1 className={classes.pageTitle}>Required Rate of Return</h1>

        <p className={classes.lede}>
          <strong>{firstName}</strong>
          {hasSecondClient && (
            <React.Fragment> and <strong>{secondFirstName}</strong></React.Fragment>
          )}
          {', '}you estimated that your Loss Tolerance was approximately{' '}
          <strong>{MINUS}{riskAbs}%</strong>.
        </p>

        {/* Loss Tolerance Panel */}
        <div className={`${classes.metricPanel} ${classes.metricPanelLoss}`}>
          <div className={classes.metricRow}>
            <div>
              <div className={classes.metricEyebrow}>Your Loss Tolerance</div>
              <div className={`${classes.metricValue} ${classes.metricValueRed}`}>
                {MINUS}{riskAbs}<span className={classes.unit}>%</span>
              </div>
              <div className={classes.metricCaption}>
                Maximum drawdown you indicated you could withstand without abandoning your plan.
              </div>
            </div>
          </div>

          <div className={classes.bandsWrap}>
            <div className={classes.bandMarkers}>
              <div className={classes.bandMarker} style={{ left: '35.71%' }}>
                <div className={classes.bandMarkerLabel}>Bonds</div>
                <span className={classes.bandMarkerStem} />
              </div>
              <div className={classes.bandMarker} style={{ left: '64.29%' }}>
                <div className={classes.bandMarkerLabel}>60/40</div>
                <span className={classes.bandMarkerStem} />
              </div>
              <div className={classes.bandMarker} style={{ left: '92.86%' }}>
                <div className={classes.bandMarkerLabel}>Stocks</div>
                <span className={classes.bandMarkerStem} />
              </div>
            </div>

            <div className={classes.bands}>
              {LOSS_BAND_COLORS.map((color, i) => (
                <div
                  key={i}
                  className={classes.band}
                  style={{ background: color, opacity: i === activeLossBand ? 1 : 0.26 }}
                />
              ))}
            </div>

            <div className={classes.youRow}>
              <div className={classes.youMarker} style={{ left: lossYouLeft }}>
                <span className={classes.youMarkerStem} />
                <div className={classes.youMarkerLabel}>You</div>
              </div>
            </div>

            <div className={classes.bandLabels}>
              {LOSS_BAND_LABELS.map((label, i) => (
                <div
                  key={i}
                  className={`${classes.bandLabel}${i === activeLossBand ? ` ${classes.bandLabelActive}` : ''}`}
                >
                  {label}
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className={classes.bodyCopy}>
          Using data from your Client Profile and other inputs (i.e. taxes, social security,
          inflation), Cy has calculated that you will need to earn a{' '}
          <strong>{rrorSign}{rrorAbs}%</strong> annualized rate of return on your investments to
          meet your retirement goals. This is referred to as your Required Rate of Return (RRoR).
        </p>

        {/* Required Rate of Return Panel */}
        <div className={`${classes.metricPanel} ${classes.metricPanelReturn}`}>
          <div className={classes.metricRow}>
            <div>
              <div className={classes.metricEyebrow}>Your Required Rate of Return</div>
              <div className={`${classes.metricValue} ${classes.metricValueGreen}`}>
                {rrorSign}{rrorAbs}<span className={classes.unit}>%</span>
              </div>
              <div className={classes.metricCaption}>
                Net annualized return needed across your indicated time horizon to achieve your goals.
              </div>
            </div>
          </div>

          <div className={classes.bandsWrap}>
            <div className={classes.bandMarkers}>
              <div className={classes.bandMarker} style={{ left: '8.33%' }}>
                <div className={classes.bandMarkerLabel}>Bonds</div>
                <span className={classes.bandMarkerStem} />
              </div>
              <div className={classes.bandMarker} style={{ left: '41.67%' }}>
                <div className={classes.bandMarkerLabel}>60/40</div>
                <span className={classes.bandMarkerStem} />
              </div>
              <div className={classes.bandMarker} style={{ left: '58.33%' }}>
                <div className={classes.bandMarkerLabel}>Stocks</div>
                <span className={classes.bandMarkerStem} />
              </div>
            </div>

            <div className={classes.bands}>
              {RETURN_BAND_COLORS.map((color, i) => (
                <div
                  key={i}
                  className={classes.band}
                  style={{ background: color, opacity: i === activeReturnBand ? 1 : 0.26 }}
                />
              ))}
            </div>

            <div className={classes.youRow}>
              <div className={classes.youMarker} style={{ left: returnYouLeft }}>
                <span className={classes.youMarkerStem} />
                <div className={classes.youMarkerLabel}>You</div>
              </div>
            </div>

            <div className={classes.bandLabels}>
              {RETURN_BAND_LABELS.map((label, i) => (
                <div
                  key={i}
                  className={`${classes.bandLabel}${i === activeReturnBand ? ` ${classes.bandLabelActive}` : ''}`}
                >
                  {label}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={classes.pullQuote}>
          <p className={classes.pullQuoteText}>
            With your personalized benchmarks in place, Cy will now recommend a portfolio designed
            to meet your needs.
          </p>
        </div>

        <p className={classes.disclosureText}>
          <strong>Past performance does not guarantee future results.</strong> The Bonds, 60/40,
          and Stocks reference markers are plotted on the band that most closely matches each
          index's historical annualized return range between January 1, 2000 through December 31,
          2024. Bonds = Bloomberg U.S. Aggregate Bond Index. Stocks = S&P 500 Total Return Index.
          60/40 = a composite of the two, rebalanced annually. Indexes are unmanaged; you cannot
          invest directly in an index.
        </p>

        <p className={classes.disclosureText}>
          Cy uses quantitative research and advanced mathematics to identify available managers who
          have demonstrated superior risk and return outcomes over several full market cycles to
          optimize manager selection and portfolio construction. Please find a more detailed
          explanation of our process, along with its limitations, in the Summary section of your
          experience.
        </p>

        <a href="#" className={classes.disclosuresLink}>See Important Disclosures</a>

        {/*{showRRoRDialog && this.invalidRRoRModal(showRRoRDialog, () => this.setState({ userClosedDialog: true }), curHouse.rror)}*/}

        <div className={classes.controller}>
          <Link to={`/Portal/household/${householdId}/portfolio`}>
            <button className={classes.saveButtonNavItem}>
              Save
              <DoubleArrowRight />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

RoRReturn.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  portfolio: PropTypes.object.isRequired,
  household: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  householdId: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let householdId = ownProps.match.params.householdId;
  return {
    householdId,
    household: state.household,
    user: state.user,
    portfolio: state.portfolio,
    app: state.app,
    appName: state.app.appName,
  };
};

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(RoRReturn));



// WEBPACK FOOTER //
// ./src/containers/PortfolioReturn/index.jsx